function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { useToggler } from '@cbhq/cds-common/hooks/useToggler';
import { IconButton } from '@cbhq/cds-web/buttons/IconButton';
import { Collapsible } from '@cbhq/cds-web/collapsible/Collapsible';
import { componentsThemeMap, colorToVariable } from '../../componentsThemeMap.js';
import '../../ui/Div/index.js';
import { accordionCellRichTextOptions } from '../../ui/RichText/options/accordionCellRichTextOptions.js';
import { RichText } from '../../ui/RichText/RichText.js';
import { Text } from '../../ui/Text.js';
import { formatJSONToRichTextTable } from '../../utils/formatJSONToRichTextTable.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import { Div } from '../../ui/Div/Div.js';
function AccordionCell({
  header,
  body,
  borderBottom,
  json,
  htmlId,
  style = 'default'
}) {
  const _useToggler = useToggler(true),
    _useToggler2 = _slicedToArray(_useToggler, 2),
    collapsed = _useToggler2[0],
    toggle = _useToggler2[1].toggle;
  const _componentsThemeMap$s = componentsThemeMap[style],
    foreground = _componentsThemeMap$s.foreground,
    foregroundSecondary = _componentsThemeMap$s.foregroundSecondary,
    borderLine = _componentsThemeMap$s.borderLine;
  const richTextTableFromJson = json && formatJSONToRichTextTable(json);
  const finalBody = body && json ? _objectSpread(_objectSpread({}, body), {}, {
    content: [...(body?.content ?? []), ...(richTextTableFromJson?.content ?? [])]
  }) : body || richTextTableFromJson;
  const borderStyle = `1px solid ${colorToVariable(borderLine || 'line')}`;
  return /*#__PURE__*/jsxs(Div, {
    id: htmlId,
    width: "100%",
    spacingVertical: 4,
    justifyContent: "flex-start",
    alignItems: "flex-start",
    flexDirection: "column",
    css: {
      borderTop: borderStyle,
      borderBottom: borderBottom ? borderStyle : undefined
    },
    children: [/*#__PURE__*/jsxs(Div, {
      justifyContent: "space-between",
      alignItems: "center",
      width: "100%",
      onClick: toggle,
      children: [/*#__PURE__*/jsx(Div, {
        flexGrow: 1,
        flexShrink: 1,
        spacingEnd: 4,
        children: header && /*#__PURE__*/jsx(Text, {
          as: "p",
          color: foreground,
          spacingEnd: {
            md: 10
          },
          variant: {
            sm: 'title3',
            md: 'title2'
          },
          children: header
        })
      }), /*#__PURE__*/jsx(IconButton, {
        name: collapsed ? 'add' : 'minus',
        variant: style === 'primary' ? 'secondary' : 'foregroundMuted',
        transparent: true
      })]
    }), finalBody && /*#__PURE__*/jsx(Div, {
      width: "100%",
      css: {
        '& > div': {
          width: '100%'
        },
        '& table': {
          width: '100%'
        }
      },
      children: /*#__PURE__*/jsx(Collapsible, {
        collapsed: collapsed,
        maxHeight: 1600,
        children: /*#__PURE__*/jsx(Div, {
          flexDirection: "column",
          spacingTop: 4,
          width: "100%",
          children: /*#__PURE__*/jsx(RichText, {
            content: finalBody,
            richTextOptions: accordionCellRichTextOptions,
            color: foregroundSecondary
          })
        })
      })
    })]
  });
}
export { AccordionCell as default };
//# sourceMappingURL=AccordionCell.js.map
